import "liquid-ajax-cart";

import Alpine from 'alpinejs'
import AlpineCollapse from '@alpinejs/collapse'
import AlpineFocus from '@alpinejs/focus'
import AlpineMorph from '@alpinejs/morph'
import AlpineAnchor from '@alpinejs/anchor'
import AlpineGlobals from '../js/alpine/index.js'
import helpers, { hasBodyClass } from '../js/helpers.js'

// Dynamic imports
// hasBodyClass('product-template') && import('../js/prodify.js')

const ns = 'slayed'

window.slayedNamespace = ns
window[ns] = (window[ns] || {})
window[ns].helpers = helpers

for (const [key, value] of Object.entries(helpers)) {
  window[ns].helpers[key] = value
}

// Register and initialize AlpineJS
window.Alpine = Alpine

Alpine.plugin(
  [
    AlpineCollapse,
    AlpineFocus,
    AlpineMorph,
    AlpineAnchor
  ]
)
AlpineGlobals.register(Alpine)
Alpine.start()

// Hide the Shopify preview bar when in development
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('DOMContentLoaded', () => {
    var css = '#preview-bar-iframe { display: none !important; }',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    head.appendChild(style)

    style.appendChild(document.createTextNode(css))
  })
}



// // Add this to your theme.js or in a script tag in theme.liquid
// document.addEventListener('DOMContentLoaded', function() {
//   // Target all Shopify customer forms
//   const customerForms = document.querySelectorAll('form[action*="/account"], form[action*="/customer"]');
  
//   customerForms.forEach(form => {
//     form.addEventListener('submit', function(e) {
//       let hasErrors = false;
//       const errors = [];
      
//       // Check all required inputs
//       const inputs = form.querySelectorAll('input[type="email"], input[type="password"], input[name*="customer"]');
      
//       inputs.forEach(input => {
//         // Clear previous errors
//         const errorDiv = input.parentElement.querySelector('.form-error');
//         if (errorDiv) errorDiv.remove();
        
//         // Email validation
//         if (input.type === 'email' && input.name.includes('email')) {
//           if (!input.value.trim()) {
//             showError(input, 'Email is required');
//             hasErrors = true;
//           } else if (!isValidEmail(input.value)) {
//             showError(input, 'Please enter a valid email');
//             hasErrors = true;
//           }
//         }
        
//         // Password validation
//         if (input.type === 'password' && input.name.includes('password')) {
//           if (!input.value) {
//             showError(input, 'Password is required');
//             hasErrors = true;
//           }
//         }
//       });
      
//       if (hasErrors) {
//         e.preventDefault();
//         e.stopPropagation();
//         return false;
//       }
//     });
//   });
  
//   function showError(input, message) {
//     const errorDiv = document.createElement('div');
//     errorDiv.className = 'form-error';
//     errorDiv.textContent = message;
//     errorDiv.style.color = 'red';
//     errorDiv.style.fontSize = '0.875rem';
//     errorDiv.style.marginTop = '0.25rem';
//     input.parentElement.appendChild(errorDiv);
//     input.classList.add('error');
//   }
  
//   function isValidEmail(email) {
//     return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//   }
// });